import React, { useState, useEffect } from "react";
import { Table, Button, Card } from "react-bootstrap";
import ModalCategoria from "./modalCategoria";
import {buscarCategoriaServicio} from "../service/productos/obtenerCategoriasService";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../AuthContext";
import Swal from "sweetalert2";
import {mensajeExitoCargando, mesanjeExitoPersonalizado} from "../helpers/mensajesSwalExito";
import {editarCategoriaService, guardarCategoriaService} from "../service/categorias/categoriasService";
import {mensajeErrorPersonalizado} from "../helpers/mensajesSwalError";

const ListaCategoria = () => {
    const navigate = useNavigate();
    const { verificacionToken } = useAuth();
    const [categorias, setCategorias] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [categoriaEditar, setCategoriaEditar] = useState(null);

    useEffect(() => {
        verificacionToken("ROLE_DUENO");
        cargarCategorias();
    }, []);

    const cargarCategorias = async () => {
        const respuesta = await buscarCategoriaServicio()

        if (respuesta[0]) {
            setCategorias(respuesta[1]);
        } else {
            if (respuesta[1] === 400) {
                setCategorias([]);
            } else if (respuesta[1] === 401) {
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                navigate("/no-autorizado");
            } else {
                navigate("/no-encontrado");
            }
        }
    };

    const abrirAgregar = () => {
        setCategoriaEditar(null);
        setModalShow(true);
    };

    const abrirEditar = (categoria) => {
        setCategoriaEditar(categoria);
        setModalShow(true);
    };

    const generarCategoria = async (data) => {
        const respuesta = await guardarCategoriaService(data.nombre)
        if (respuesta[0]) {
            setCategorias(prev => [
                ...prev,
                { id: respuesta[1].id, nombre: respuesta[1].nombre }
            ]);
            mesanjeExitoPersonalizado('Se agrego con exito la categoria!!')
        } else {
            if (respuesta[1] === 400) {
                mensajeErrorPersonalizado('No se pudo actualizar la categoria!!')
            } else if (respuesta[1] === 401) {
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                navigate("/no-autorizado");
            } else {
                navigate("/no-encontrado");
            }
        }
    }

    const editarCategoria = async (data) => {
        const respuesta = await editarCategoriaService(data.id, data.nombre)
        if (respuesta[0]) {
            setCategorias(prev =>
                prev.map(c =>
                    c.id === categoriaEditar.id ? { ...c, nombre: data.nombre } : c
                )
            );
            mesanjeExitoPersonalizado('Se edito con exito la categoria!!')
        } else {
            if (respuesta[1] === 400) {
                mensajeErrorPersonalizado('No se pudo actualizar la categoria!!')
            } else if (respuesta[1] === 401) {
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                navigate("/no-autorizado");
            } else {
                navigate("/no-encontrado");
            }
        }
    }

    const guardarCategoria = (data) => {
        if (categoriaEditar) {
            Swal.fire({
                title: "Estas seguro?",
                text: "Editar Categoria!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Editar!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    mensajeExitoCargando();
                    await editarCategoria(data);
                }
            });

        } else {
            Swal.fire({
                title: "Estas seguro?",
                text: "Agregar Categoria!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Generar!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    mensajeExitoCargando();
                    await generarCategoria(data);
                }
            });
        }

        setModalShow(false);
    };

    return (
        <div className="container mt-4">
            <Card className="shadow-sm border-0">
                <Card.Header
                    className="text-white"
                    style={{
                        background: "linear-gradient(90deg,#ff9ccf,#d63384)"
                    }}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <span style={{ fontWeight: "bold" }}>📁 Categorías</span>

                        <Button
                            style={{
                                background: "#d63384",
                                border: "none",
                                borderRadius: "6px"
                            }}
                            onClick={abrirAgregar}
                        >
                            ➕ Agregar Categoría
                        </Button>
                    </div>
                </Card.Header>

                <Card.Body>
                    <Table striped hover responsive>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Acciones</th>
                        </tr>
                        </thead>

                        <tbody>
                        {categorias.map((c, index) => (
                            <tr key={c.id}>
                                <td>{index + 1}</td>
                                <td>{c.nombre}</td>
                                <td>
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        onClick={() => abrirEditar(c)}
                                    >
                                        ✏️ Editar
                                    </Button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* MODAL */}
            <ModalCategoria
                show={modalShow}
                onHide={() => setModalShow(false)}
                onSave={guardarCategoria}
                categoria={categoriaEditar}
            />
        </div>
    );
};

export default ListaCategoria;